"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("./customer-group/index.vue"));
var _index2 = _interopRequireDefault(require("./customer-rank/index.vue"));
var _index3 = _interopRequireDefault(require("./customer-source/index.vue"));
var _CustomerTable = _interopRequireDefault(require("./CustomerTable.vue"));
var _index4 = _interopRequireDefault(require("./skin-status/index.vue"));
var CustomerPage = /*#__PURE__*/function (_Vue) {
  function CustomerPage() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "tabName", "list");
    return _this;
  }
  (0, _inherits2.default)(CustomerPage, _Vue);
  return (0, _createClass2.default)(CustomerPage);
}(_vuePropertyDecorator.Vue);
CustomerPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerTable: _CustomerTable.default,
    SkinStatus: _index4.default,
    CustomerSource: _index3.default,
    CustomerGroup: _index.default,
    CustomerRank: _index2.default
  }
})], CustomerPage);
var _default = exports.default = CustomerPage;